// Login to NVR
export function loginNVR(loginSuccess, loginFailed, username, password, serialNumber, deviceType) {
    window.cordova.exec(loginSuccess, loginFailed, "DLinkCameraPlugin", "loginNVR", [username, password, serialNumber, deviceType]);
};